import { React, useEffect, useState } from 'react'
import UserPanelTitle from '../UserPanelTitle/UserPanelTitle'
import './UserOrder.css'
import ModalFactor from '../ModalFactor/ModalFactor';
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';
export default function UserOrder() {
  const [selectModalIndex, setSelectModalIndex] = useState(null)
  const handleShow = (index) => setSelectModalIndex(index);
  const [factors, setFactors] = useState([]);

  useEffect(() => {
    axiosConfig.get('api/factors').then((res) => {
      setFactors(res.data)
    })
  }, [])
  return (
    <>
      <div className='user-order'>
        <UserPanelTitle title='سفارش های شما' />
        <div className='user-order-table'>
          <table>
            <thead>
              <tr>
                <th>کد پیگیری</th>
                <th>تاریخ سفارش</th>
                <th>مبلغ</th>
                <th>لینک</th>
              </tr>
            </thead>
            <tbody>
              {
                factors?.map((item, index) => (
                  <tr className='table-item'>
                    <td>{item.trackingCode}</td>
                    <td>
                      {new Date(
                        item.registerDate
                      ).toLocaleDateString("fa-IR")}
                    </td>
                    <td>{item.amount?.toLocaleString("fa-IR")} تومان</td>
                    <td>
                      <button className='table-btn' onClick={() => handleShow(index)}>مشاهده فاکتور</button>
                    </td>
                    <ModalFactor selectModalIndex={selectModalIndex} index={index} item={item} setSelectModalIndex={setSelectModalIndex} />
                  </tr>
                ))
              }
            </tbody>
          </table>

        </div>
        <div className='user-order-table-responsive'>

          <table>
            <tbody>
              {
                factors?.map((item, index) => (
                  <tr className='table-item'>
                    <td>{item.trackingCode}</td>
                    <td>
                      {new Date(
                        item.registerDate
                      ).toLocaleDateString("fa-IR")}
                    </td>
                    <td>{item.amount?.toLocaleString("fa-IR")} تومان</td>
                    <td>
                      <button className='table-btn' onClick={() => handleShow(index)}>مشاهده فاکتور</button>
                    </td>
                    <ModalFactor selectModalIndex={selectModalIndex} index={index} item={item} setSelectModalIndex={setSelectModalIndex} />
                  </tr>
                ))
              }

            </tbody>
          </table>

        </div>
      </div>
    </>

  )
}
